

const detectScroll = (event, pixels=-1, callBack) => {
    if ((event.target.scrollHeight - Math.round(event.target.scrollTop)) <= event.target.offsetHeight + (pixels >= 0 ? pixels : event.target.offsetHeight / 2)) {
        callBack()
    }
}

export default detectScroll